export default class Component {
    constructor(options = {}) {
        this.state = null;
        this.engine = null;
        this.context = null;
        this.options = options;
    }

    init() {}

    dispose() {}

    update() {}

    render() {}

    input(event) {}

    handleEvent(event) {}
}
